//@ helpers
const { APIGet } = require('utilities/APIRequestHelper');

//@ constants
const actionTypes = require('../constants/actionTypes');
// @ constants
const {
    OKCONSENTS_EMPTY_VALUE,
    OKCONSENTS_NEGATIVE_VALUE,
    OKCONSENTS_POSITIVE_VALUE,
    OKCONSENTS_LEGITIMATE,
    OKCONSENTS_CONSENTS
} = require('../constants/constants');

const reset = () => ({
    type: actionTypes.OKCONSENTS_RESET
});

const getConsentsRequest = () => ({
    type: actionTypes.OKCONSENTS_GET_CONSENTS_REQUEST
});

const getConsentsFailure = (errorDescription) => ({
    type: actionTypes.OKCONSENTS_GET_CONSENTS_FAILURE,
    payload: {
        error: errorDescription
    }
});

const updateConsentsRequest = () => ({
    type: actionTypes.OKCONSENTS_UPDATE_CONSENTS_REQUEST
});

const updateConsentsFailure = (errorDescription) => ({
    type: actionTypes.OKCONSENTS_UPDATE_CONSENTS_FAILURE,
    payload: {
        error: errorDescription
    }
});

const updateConsentsSuccess = () => ({
    type: actionTypes.OKCONSENTS_UPDATE_CONSENTS_SUCCESS
});

const getConsentsSuccess = (config, placementId) => ({
    type: actionTypes.OKCONSENTS_GET_CONSENTS_SUCCESS,
    payload: {
        config,
        placementId
    }
});

const getConsents = (placementId, getAllConsents) => (dispatch) => {
    dispatch(getConsentsRequest());
    const requestData = {
        header: {
            version: 2,
        },
        query: {
            placementId,
            status: getAllConsents ? [OKCONSENTS_POSITIVE_VALUE, OKCONSENTS_EMPTY_VALUE, OKCONSENTS_NEGATIVE_VALUE] : [OKCONSENTS_EMPTY_VALUE, OKCONSENTS_NEGATIVE_VALUE]
        }
    };
    return APIGet({
        dispatch,
        endpoint: 'consents',
        params: requestData
    })
        .then(response => dispatch(getConsentsSuccess(response, placementId)))
        .catch(response => {
            if (!!response.error) {
                dispatch(getConsentsFailure(response.error.description));
            } else {
                throw response;
            }
        });
};

const updateConsentStatus = (questionId, status) => ({
    type: actionTypes.OKCONSENTS_UPDATE_CONSENT_STATUS,
    payload: {
        questionId,
        status
    }
});

const updateAllConsentsStatus = (status, consentsSave = null) => ({
    type: actionTypes.OKCONSENTS_UPDATE_ALL_CONSENTS_STATUS,
    payload: {
        status,
        consentsSave
    }
});

const updateCheckboxChannel = (questionId, channelIndex) => ({
    type: actionTypes.OKCONSENTS_UPDATE_CHECKBOX_CHANNEL,
    payload: {
        questionId,
        channelIndex
    }
});

module.exports = {
    getConsents,
    reset,
    updateAllConsentsStatus,
    updateCheckboxChannel,
    updateConsentStatus,
    updateConsentsFailure,
    updateConsentsRequest,
    updateConsentsSuccess,
};
